import React, {useEffect, useState} from 'react';
import styles from './index.module.less';
import Header from '../../../components/header';
import Bottom from '../../../components/contact';
import Reserve from '../../../components/reserve';
import BasicLayout from '../../../layout/basicLayout';
import PageTop from '../../../components/pageTop';
import Solution_Module from '../../../components/module/solution';
import {SOLUTIONS} from '../../../contant';
import {useHistory} from 'react-router-dom';
import Module from "../../../components/module";

const Solutions = (props) => {
    const [solution, setSolution] = useState({
        type: '',
        banner: '',
        title: '',
        title_long: '',
        description: '',
        fanganzhengtijiagou: '',
        shujukeshihuadaping: [],
        fanganjiazhiliangdian: [],
        yingjianchanpintushi: [],
    });
    const [other, setOther] = useState([]);
    const [nenglizhichengpingtaiIndex, setNenglizhichengpingtaiIndex] = useState(0);
    const history = useHistory();
    useEffect(() => {
        initData()
    }, []);
    const initData = () => {
        let state = props.location.pathname.split('/')[2]
        let type = props.location.state ? props.location.state.type : state
        const item = SOLUTIONS.find(ele => ele.type === type);
        setSolution(item);
        const otherArr = SOLUTIONS.filter(ele => ele.type !== type);
        const arrNew = [];
        for (let i = 0; i < 4; i++) {
            const _num = Math.floor(Math.random() * otherArr.length);
            arrNew.push(...otherArr.splice(_num, 1));
        }
        setOther(arrNew)
    }

    useEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0
        initData()
    }, [props.location.state])

    return <BasicLayout>
        <Header fixed/>
        <div className={'content_wrapper'}>

            <PageTop bg={solution.banner}
                     title={solution.title_long}
                     description={solution.description}
                     isSolution={true}
            />
            <Solution_Module title={'方案整体架构'} bg={'/img/solution/common/module_bg/01.png'} isFirst={true}
                             style={{padding: '50px 18%'}}>
                <img className={styles.fanganzhengtijiagou_img} src={solution.fanganzhengtijiagou}/>
            </Solution_Module>
            {
                solution.type === 'card' &&
                <div>
                    <Solution_Module title={'多样化介质'} bg={'/img/solution/common/module_bg/04.png'}>
                        <div className={styles.duoyanghuajiezhi_content}>{solution.duoyanghuajiezhi.content}</div>
                        <img className={styles.duoyagnhuajiezhi_img} src={solution.duoyanghuajiezhi.img}/>
                    </Solution_Module>
                    <Solution_Module title={'能力支撑平台'} bg={'/img/solution/common/module_bg/03.png'}>
                        <div className={styles.nenglizhichengpingtai}>
                            <div className={styles.nenglizhichengpingtai_tabs}>
                                {
                                    solution.nenglizhichengpingtai.map((item, i) => (
                                        <div
                                            className={styles.nenglizhichengpingtai_name}
                                            style={i === nenglizhichengpingtaiIndex ? {
                                                borderLeft: '2px solid #327DF9',
                                                width: '100%',
                                                height: '48px',
                                                background: 'linear-gradient(89deg,#ffffff 4%, #ebf1ff 100%)'
                                            } : {}}
                                        >
                                            <img className={styles.nenglizhichengpingtai_icon}
                                                 src={solution.nenglizhichengpingtai[i].icon}/>
                                            <div
                                                onClick={() => setNenglizhichengpingtaiIndex(i)}
                                            >{item.name}</div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className={styles.nenglizhichengpingtai_content}>
                                <div
                                    className={styles.nenglizhichengpingtai_title}>{solution.nenglizhichengpingtai[nenglizhichengpingtaiIndex].content}</div>
                                <div
                                    className={styles.nenglizhichengpingtai_message}>{solution.nenglizhichengpingtai[nenglizhichengpingtaiIndex].message}</div>
                            </div>
                            <img className={styles.nenglizhichengpingtai_img}
                                 src={solution.nenglizhichengpingtai[nenglizhichengpingtaiIndex].img}/>
                        </div>
                    </Solution_Module>
                </div>
            }
            {
                solution.type === 'sell' ?
                    <Solution_Module title={'硬件产品图示'} bg={'/img/solution/common/module_bg/02.png'}>
                        <div className={styles.product_img_wrapper}>
                            <img style={{marginRight: 20}} src={solution.yingjianchanpintushi[0]}/>
                            <img src={solution.yingjianchanpintushi[1]}/>
                        </div>
                    </Solution_Module>
                    :
                    solution.type === 'live' || solution.type === 'attendance' || solution.type === 'welcome' ?
                        <div>
                            {
                                solution.type === 'live' &&
                                solution.yingjianchanpintushi?.map((e, i) => {
                                    return <div key={i}>
                                        <Solution_Module title={e.title}
                                                         bg={'/img/solution/common/module_bg/06.png'}>
                                            <img style={{marginTop: '50px'}} className={styles.zhihuishenghuo_product_img_wrapper} src={e.img}/>
                                        </Solution_Module>
                                    </div>
                                })
                            }
                            {
                                solution.type === 'welcome' &&
                                <Solution_Module title={'智慧迎新AI助手'}
                                                 bg={'/img/solution/common/module_bg/06.png'}>
                                    <div className={styles.ai_data_screen_wrapper} style={{marginTop: 0}}>
                                        <img className={styles._img} src={solution.yingjianchanpintushi[0].img}/>
                                        <div style={{marginTop: '10%'}}>
                                            <div className={styles._title}>{solution.yingjianchanpintushi[0].title}</div>
                                            <div className={styles._description}>{solution.yingjianchanpintushi[0].description}</div>
                                        </div>
                                    </div>
                                </Solution_Module>
                            }
                            {
                                solution.type === 'attendance' && solution.yingjianchanpintushi?.map((e, i) => {
                                  return <Solution_Module title={e.title} bg={e.bg}>
                                      {
                                          e.content && <div className={styles.zhihuikaopin_yingjian_content}>{e.content}</div>
                                      }
                                      <img style={{marginTop: '50px'}}
                                           className={styles.zhihuitongxing_yingjian_img} src={e.img}/>
                                  </Solution_Module>
                                })
                            }
                            <Solution_Module title={'数据可视化大屏'} bg={'/img/solution/common/module_bg/02.png'}>
                                {solution.shujukeshihuadaping.map(e => {
                                    return <div className={styles.data_screen_wrapper}>
                                        <div>
                                            <div className={styles.title}>{e.title}</div>
                                            <div className={styles.description}>{e.description}</div>
                                            <div>
                                                <span className={styles.button} onClick={() => {
                                                    history.replace({
                                                        pathname: `/about/contact`,
                                                    });
                                                }}>立即咨询</span>
                                            </div>
                                        </div>
                                        <img className={styles.data_screen_img} src={e.img}/>
                                    </div>
                                })}
                            </Solution_Module>
                        </div>
                        :
                        solution.type === 'portal' ?
                            <>
                                <Solution_Module title={'校园门户WEB端'} bg={'/img/solution/common/module_bg/02.png'}>
                                    <img className={styles.fanganzhengtijiagou_img} src={solution.xiaoyuanmenhu_web}/>
                                </Solution_Module>
                                <Solution_Module title={'校园门户APP端'} bg={'/img/solution/common/module_bg/04.png'}>
                                    <img className={styles.fanganzhengtijiagou_img} src={solution.xiaoyuanmenhu_app}/>
                                </Solution_Module>
                            </>
                            :
                            solution.shujukeshihuadaping && solution.type !== 'ai-model' ?
                                <Solution_Module title={'数据可视化大屏'} bg={'/img/solution/common/module_bg/02.png'}>
                                    {solution.shujukeshihuadaping?.map(e => {
                                        return <div className={styles.data_screen_wrapper}>
                                            <div>
                                                <div className={styles.title}>{e.title}</div>
                                                <div className={styles.description}>{e.description}</div>
                                                <div>
                                                    <span className={styles.button} onClick={() => {
                                                        history.replace({
                                                            pathname: `/about/contact`,
                                                        });
                                                    }}>立即咨询</span>
                                                </div>
                                            </div>
                                            <img className={styles.data_screen_img} src={e.img}/>
                                        </div>
                                    })}
                                </Solution_Module> : <></>
            }
            {
                solution.type === 'ai-model' ?
                    <>
                        <Solution_Module title={'AI 重构教育服务新范式'} bg={'/img/solution/common/module_bg/02.png'}>
                            {solution.shujukeshihuadaping?.map(e => {
                                return <div className={styles.ai_data_screen_wrapper}>
                                    <div>
                                        <div className={styles._title}>{e.title}</div>
                                        <div className={styles._description}>{e.description}</div>
                                    </div>
                                    <img className={styles._img} src={e.img}/>
                                </div>
                            })}
                        </Solution_Module>
                        <Solution_Module title={'智慧迎新AI助手'} bg={'/img/solution/common/module_bg/06.png'}>
                            {solution.zhihuiyingxinaizhushou?.map(e => {
                                return <div className={styles.ai_data_screen_wrapper}>
                                    <img className={styles._img2} src={e.img}/>
                                    <div>
                                        <div className={styles._title2}>{e.title}</div>
                                        <div className={styles._description}>{e.description}</div>
                                    </div>
                                </div>
                            })}
                        </Solution_Module>
                    </> : <></>
            }
            <Solution_Module title={'方案价值亮点'} bg={'/img/solution/common/module_bg/03.png'}>
                <div className={styles.project_value_wrapper}>
                    <div className={styles.content}>
                        {solution.fanganjiazhiliangdian.map((e, index) => {
                            return <span className={styles.item_wrapper}>
                                <div className={styles.item}>
                                    <div className={styles.img_wrapper}>
                                        <img className={styles.img}
                                             src={`/img/solution/common/fanganjiazhiliangdian_icon/icon_0${index + 1}.png`}/>
                                    <div className={styles.line}/>
                                    </div>
                                    <div>
                                        <div className={styles.title}>{e.title}</div>
                                        <div className={styles.description}>{e.description}</div>
                                    </div>
                                </div>
                            </span>
                        })}
                    </div>
                </div>
            </Solution_Module>


            <Module title={'相关方案'} eng={'More solutions'} bg={''}>
                <div className={styles.other_solutions_wrapper}>
                    {<div className={styles.scene_row_wrapper}>
                        {other.map(
                            (item, index) => {
                                return <div key={`scene_item${index}`}
                                            onClick={() => {
                                                props.history.replace({
                                                    pathname: `${item.to}`,
                                                    state: {type: item.type},
                                                });
                                            }}
                                            className={`${styles.scene_item} scene_item${index}`}>
                                    <div className={styles.mask}/>
                                    <img className={'img_bg'}
                                         src={item.banner_M}/>
                                    <div className={styles.info_wrapper}>
                                        <div className={styles.icon_wrapper}>
                                            <div>{item.title}</div>
                                        </div>
                                        <div className={styles.intro}>{item.description}</div>
                                    </div>
                                </div>;
                            })}
                    </div>}
                </div>
            </Module>
        </div>
        <Bottom/>
        <Reserve/>
    </BasicLayout>;
};

export default Solutions;
